<div class="flex w-full justify-end">
  <pay-lib-language-selector />
</div>
